import React, { Children, Component } from 'react'
import { Flex, Box } from 'reflexbox'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class ListItem extends Component {
  order = {
    'left': 0,
    'right': 1,
    'rightAction': 2
  }

  getOrder(pos) {
    const order = this.order[pos]
    return (order === undefined) ? this.order.right : order
  }

  orderChildren() {
    return Children.toArray(this.props.children)
      .sort((a, b) => this.getOrder(a.props.pos) - this.getOrder(b.props.pos))
  }

  renderChildren() {
    const styles = Object.keys(this.order)
    return this.orderChildren().map((child, index) => {
      const { pos, ...childProps } = child.props
      const styleIndex = this.getOrder(pos)
      return (
        <Box
          styleName={`${styles[styleIndex]}Item`}
          key={index}>
          { React.createElement(child.type, childProps) }
        </Box>
      )
    })
  }

  render() {
    return (
      <Flex>
        { this.renderChildren() }
      </Flex>
    )
  }
}

export default CSSModules(ListItem, styles)
